import { ApiService } from './index'
import { Alert, AlertRule, ApiResponse } from '@types'

export interface MeasurementType {
  id: number
  name: string
  abbreviation: string
  physical_quantity: number
  show_in_charts: boolean
  show_in_alerts: boolean
  show_in_dials: boolean
  chart_group: string
  hex_color: string
}

export const alertsApi = {
  // Measurement types (for scoping an alert rule to a sensor type)
  getMeasurementTypes: () =>
    ApiService.get<ApiResponse<MeasurementType[]>>('/core/measurement-types/', {
      params: { show_in_alerts: true },
    }),

  // Alerts
  getAlerts: (params?: {
    hive_id?: number
    read?: boolean
    limit?: number
    offset?: number
  }) =>
    ApiService.get<ApiResponse<Alert[]>>('/alerts/', { params }),

  getAlert: (id: number) =>
    ApiService.get<ApiResponse<Alert>>(`/alerts/${id}/`),

  deleteAlerts: (alertIds: number[]) =>
    ApiService.post('/alerts/bulk-resolve/', { alert_ids: alertIds }),

  markAlertsAsRead: (alertIds: number[]) =>
    ApiService.post('/alerts/bulk-acknowledge/', { alert_ids: alertIds }),

  // Alert Rules
  getAlertRules: () =>
    ApiService.get<ApiResponse<AlertRule[]>>('/alert-rules/'),

  getAlertRule: (id: number) =>
    ApiService.get<ApiResponse<AlertRule>>(`/alert-rules/${id}/`),

  createAlertRule: (data: Partial<AlertRule>) =>
    ApiService.post<ApiResponse<AlertRule>>('/alert-rules/', data),

  updateAlertRule: (id: number, data: Partial<AlertRule>) =>
    ApiService.patch<ApiResponse<AlertRule>>(`/alert-rules/${id}/`, data),

  deleteAlertRule: (id: number) =>
    ApiService.delete(`/alert-rules/${id}/`),

  // Default alert rules
  getDefaultAlertRules: () =>
    ApiService.get<ApiResponse<AlertRule[]>>('/alert-templates/'),

  createDefaultAlertRules: () =>
    ApiService.post<ApiResponse<AlertRule[]>>('/alert-rules/check/'),

  // Test alert rule
  testAlertRule: (id: number, testValue: number, notes?: string) =>
    ApiService.post<ApiResponse<any>>(`/alert-rules/${id}/test/`, { test_value: testValue, notes }),
}
